import { defineStore } from "pinia";

export const useNotificationsStore = defineStore({
  id: 'notifications',
  state: () => {
    return {
      notificationZoneArray: []
    }
  },
  actions: {
    unshiftNotificationZoneArray(notif) {
      this.notificationZoneArray.unshift(notif);
    },
    popNotificationZoneArray() {
      this.notificationZoneArray.pop()
    },
    sendToNotificationZone(notif) {
      this.unshiftNotificationZoneArray(notif);
      setTimeout(() => {
        this.popNotificationZoneArray();
      }, 5000)
    }
  },
  getters: {
  }
})